import { ICellRendererParams } from 'ag-grid-community';

import { Status, TextLine } from 'core/elements';
import { ValidationStatus } from 'quotes/enums';
import { Color } from 'theme/enums';
import { IColorMap } from 'theme/types';

export const colorMap: IColorMap = {
  [ValidationStatus.VALID]: Color.SUCCESS,
  [ValidationStatus.NOT_VALID]: Color.DANGER,
};

const ValidityCell = ({ value }: ICellRendererParams) => {
  if (!value) {
    return null;
  }

  return <TextLine text={<Status value={value} colorMap={colorMap} />} bold />;
};

export default ValidityCell;
